export const SET_NO_DATES_AVAILABLE_FOR_REG_SCHEDULER = 'SET_NO_DATES_AVAILABLE_FOR_REG_SCHEDULER';
export const UPDATE_TOTAL_FOR_REG_SCHEDULER = 'UPDATE_TOTAL_FOR_REG_SCHEDULER';
export const UPDATE_SQUAD_QTY_FOR_REG_SCHEDULER = 'UPDATE_SQUAD_QTY_FOR_REG_SCHEDULER';
export const SET_SELECTED_DATE = 'SET_SELECTED_DATE';
export const DISPLAY_AVAILABLE_DATES = 'DISPLAY_AVAILABLE_DATES';
export const DISPLAY_SQUADS = 'DISPLAY_SQUADS';
export const DISPLAY_BOWLER_OWNED_VIRTUAL_EVENTS = 'DISPLAY_BOWLER_OWNED_VIRTUAL_EVENTS';
export const UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER = 'UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER';
export const UPDATE_TEAM_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER = 'UPDATE_TEAM_OWNED_VIRTUAL_EVENT_QTY_FOR_REG_SCHEDULER';
export const UPDATE_SQUAD_COUNT_IN_CART_FOR_REG_SCHEDULER = 'UPDATE_SQUAD_COUNT_IN_CART_FOR_REG_SCHEDULER';
export const UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER = 'UPDATE_BOWLER_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER';
export const UPDATE_TEAM_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER = 'UPDATE_TEAM_OWNED_VIRTUAL_EVENT_COUNT_IN_CART_FOR_REG_SCHEDULER';
export const SET_CALENDAR_SELECTED_DATE = 'SET_CALENDAR_SELECTED_DATE';
export const DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED = 'DISPLAY_GUIDE_IF_SQUAD_IS_BUNDLED';



// WEBPACK FOOTER //
// ./src/features/registration/scheduler/constants.js